import React, { Component } from 'react'
import PageBase from '../components/general/PageBase'

/**
 * Essa página tem o propósito de mostrar casos de sucesso
 * de praticas influenciando indicadores, nada dela foi desenvolvida
 * para essa versão usando javascript, consultar a versão e Flutter para mais
 * detalhes
 */
export default class Casos extends Component {

    render() {
        return (
            <div>
                <PageBase left={<></>} right={<></>}/>
            </div>
        )
    }
}
